const blankToNull = require('./../../../utils').blankToNull

export function validate(record) {
  const errors = []
  if (!record.nome || record.nome.trim().length < 3) {
    errors.push({ field: 'nome', message: 'O campo nome é obrigatório e deve ter mais de 3 caracteres' })
  }
  if (!record.numeroDocumento) {
    errors.push({ field: 'numeroDocumento', message: 'O campo CNPJ é obrigatório' })
  }

  const tipoChavePix = record.tipoChavePix
  if (tipoChavePix) {
    record.tipoChavePix = tipoChavePix.id
  }

  blankToNull(record)

  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }

  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
